import { render, staticRenderFns } from "./CommunicationRecord.vue?vue&type=template&id=44ee144f"
import script from "./CommunicationRecord.vue?vue&type=script&lang=js"
export * from "./CommunicationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports